import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-12" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object,
        required: true
    }
},
  setup(__props) {

const props = __props

const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormSection, null, {
    title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createTextVNode(" HMO Accreditation Information ", -1)
    ]))]),
    description: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createTextVNode(" Relevant data and other details ", -1)
    ]))]),
    form: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextInput, {
          disabled: "",
          modelValue: item.value.hmo_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.hmo_name) = $event)),
          id: "hmo_name",
          name: "hmo_name",
          label: "HMO Accreditation Name",
          placeholder: "HMO Accreditation Name"
        }, null, 8, ["modelValue"])
      ])
    ]),
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})